import React from 'react';
import { colors, spacing, radius, fontStack } from '../design-system/tokens';

/**
 * AuthShell — shared layout for Login, Signup, ForgotPassword,
 * ResetPassword. Centered card on the bg color, blue hex logo
 * + wordmark above, subtle "Back to home" link below.
 *
 * Children render inside the white card.
 */
export default function AuthShell({ children }) {
  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: colors.bg,
        color: colors.textPrimary,
        fontFamily: fontStack,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '32px 16px',
        WebkitFontSmoothing: 'antialiased',
      }}
    >
      <a
        href="/"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 10,
          textDecoration: 'none',
          color: colors.textPrimary,
          marginBottom: spacing.lg,
        }}
      >
        <img
          src="/assets/crux-hex.png"
          alt="Curx AI"
          width="48"
          height="48"
          style={{ display: 'block' }}
        />
        <span
          style={{
            fontSize: 20,
            fontWeight: 700,
            letterSpacing: '0.02em',
            color: colors.textPrimary,
          }}
        >
          Curx AI
        </span>
      </a>

      <div className="crux-auth-card">
        {children}
      </div>

      <a
        href="/"
        style={{
          marginTop: spacing.lg,
          color: colors.textSecondary,
          fontSize: 13,
          textDecoration: 'none',
          fontFamily: fontStack,
        }}
      >
        ← Back to home
      </a>

      {/* Card responsiveness: 40px padding desktop → 24px under 480px,
          full width with 16px page padding on mobile (handled by the
          outer container's 16px padding). */}
      <style>{`
        .crux-auth-card {
          width: 100%;
          max-width: 440px;
          background: ${colors.card};
          border: 1px solid ${colors.border};
          border-radius: ${radius.lg}px;
          box-shadow: 0 1px 3px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.06);
          padding: 40px;
          box-sizing: border-box;
        }
        @media (max-width: 480px) {
          .crux-auth-card {
            padding: 24px;
          }
        }
      `}</style>
    </div>
  );
}
